import { isControl, rankWith, RuleEffect } from '@jsonforms/core';
import type { RendererProps, Rule, SchemaBasedCondition, Tester } from '@jsonforms/core';

// An empty schema validates any value, so this condition always passes.
const ALWAYS_TRUE_CONDITION: SchemaBasedCondition = { scope: '', schema: {} };

/** Hides a control unconditionally. */
export const ALWAYS_HIDDEN_RULE: Rule = { effect: RuleEffect.HIDE, condition: ALWAYS_TRUE_CONDITION };

/**
 * Testers cannot see form data, so they cannot evaluate rule conditions. Only claim HIDE rules
 * whose condition always passes; conditional HIDE rules fall through to their real controls.
 */
const hasAlwaysHiddenRule: Tester = (uischema) => {
    if (!isControl(uischema) || uischema.rule?.effect !== RuleEffect.HIDE) {
        return false;
    }
    const { condition } = uischema.rule;
    return (
        'schema' in condition &&
        typeof condition.schema === 'object' &&
        Object.keys(condition.schema).length === 0 &&
        !('failWhenUndefined' in condition && condition.failWhenUndefined === true)
    );
};

export const HiddenControlTester = rankWith(20, hasAlwaysHiddenRule);

export const HiddenControl = (_props: RendererProps) => null;
